import axios from "axios";
import { saveAs } from "file-saver";
import { PROYECT } from "services/api";
import { reportInventoryStockTypes } from "redux/reducers/Reports/reportInventoryStock/types";
import { setSnackbar, startRequestComp, stopRequestComp } from "redux/actions/search/searchActions";
import { getErrorBlob } from "helpers/extractError";

const { SET_INVENTORY_STOCK_FILTERS } = reportInventoryStockTypes;

export const getReportInventoryStockAction = ({ startDate, endDate, station, isPdf = true }) => {
  return async (dispatch, getState) => {
    const { token } = getState().login;
    dispatch(startRequestComp('loadingInventoryStock'));
    try {
      const url = `${process.env.REACT_APP_URL}${PROYECT}/reports/inventory-existance?idStation=${station.id}&start=${startDate}&end=${endDate}&pdf=${isPdf}`;
      const res = await axios.get(url, {
        headers: { authorization: token },
        responseType: "blob"
      });

      saveAs(res.data, `Reporte_Existencias_Inventario_${startDate}_${endDate}.${isPdf ? "pdf" : "xlsx"}`);
      dispatch(setSnackbar("Reporte descargado con éxito", "success"));
    } catch (err) {
      dispatch(setSnackbar(await getErrorBlob(err)));
    } finally {
      dispatch(stopRequestComp('loadingInventoryStock'));
    }
  };
};

export const setReportInventoryStockFilters = (key = "", value) => ({
  type: SET_INVENTORY_STOCK_FILTERS,
  payload: { key, value }
});
